import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'highlight',
  standalone: false,
})
export class HighlightPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(text: any, search: string): SafeHtml {
    text = String(text ?? '');
    search = String(search ?? '');

    if (!search) {
      return text;
    }

    // Split the search string into words and escape special characters
    const words = search
      .split(/\s+/)
      .map((word) => word.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&'))
      .filter((word) => word); // Remove empty strings

    if (words.length === 0) {
      return text;
    }

    // Create a regex that matches any of the words
    const regex = new RegExp(`(${words.join('|')})`, 'gi');

    // Replace matches with highlighted spans
    const highlighted = text.replace(
      regex,
      (match) => `<span class="highlight">${match}</span>`,
    );

    return this.sanitizer.bypassSecurityTrustHtml(highlighted);
  }
}
